// Enum representing the type of a parcel
export enum CustomsContentType {
  Gift = 'Gift',
  Documents = 'Documents',
  CommercialSample = 'CommercialSample',
  Product = 'Product',
  ReturnedGoods = 'ReturnedGoods',
  Other = 'Other',
}

export function isCustomsContentType(value: unknown): value is CustomsContentType {
  if (typeof value !== 'string') {
    return false;
  }
  return Object.values(CustomsContentType as Record<string, string>).includes(value);
}
